import Vue from 'vue';
import bugsnag from 'bugsnag-js';
import bugsnagVue from 'bugsnag-vue';

const bugsnagClient = bugsnag({
  apiKey: 'a54ed80324597d3a4fca923c47054af0',
  releaseStage: process.env.VUE_APP_RELEASE_STAGE
});

bugsnagClient.use(bugsnagVue(Vue));

export default bugsnagClient;
